import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlace = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 9.955C10 11.06 10.895 11.955 12 11.955C13.105 11.955 14 11.06 14 9.955V9.918C14 8.813 13.105 7.918 12 7.918C10.895 7.918 10 8.813 10 9.918M5.127 10.045V9.873C5.127 6.077 8.204 3 12 3C15.796 3 18.873 6.077 18.873 9.873V10.045C18.873 13.506 14.491 18.716 12.725 20.676C12.336 21.108 11.664 21.108 11.275 20.676C9.509 18.716 5.127 13.506 5.127 10.045Z",
		stroke: "#111827",
		strokeWidth: 1.4468,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgPlace);
export default ForwardRef;
